import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme } from "common";

class MagstimInputGroupDate extends React.Component {

    render() {

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText>{this.props.title}</InputGroupText>
            </InputGroupAddon>
            <InputGroup size={CurrentTheme().ControlSize}>
                <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <Input type="date" name={this.props.name} tag={Field} disabled={this.props.disabled}  className={`form-control ${ this.props.touched && this.props.errors ? "is-invalid" : "" }`} />
                <ErrorMessage component="div" name={this.props.name} className="invalid-feedback" />
            </InputGroup>
            </>
        );
    }
}

MagstimInputGroupDate.propTypes = {
    title: PropTypes.string,
    name:PropTypes.string,
    touched:PropTypes.bool,
    errors:PropTypes.string,
    disabled:PropTypes.bool
};

MagstimInputGroupDate.defaultProps = {
    title: "",
    name:"",
    touched:false,
    errors:undefined,
    disabled:false,
};

export default MagstimInputGroupDate